import { ensureSafeComponent } from '@embroider/util';
import { importSync } from '@embroider/macros';
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class SitePaymentLinkRoute extends Route {
  @service router;
  @service session;
  @service store;
  @service fastboot;
  @service currentPractice;

  model(params) {
    if (this.fastboot.isFastBoot) {
      return;
    }
    if (!this.isFeatureFlagEnabled) {
      return this.router.transitionTo('not-found', 'errors/404');
    }

    return this.store.adapterFor('payment-link').queryRecord(params.uuid);
  }

  beforeModel(transition) {
    this.session.requireAuthentication(transition, 'home');
  }

  get isFeatureFlagEnabled() {
    return this.currentPractice.get('featurePaymentLinks');
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    let component;
    switch (model.status) {
      case 'active':
        component = 'payment-link/payment-form';
        break;
      case 'paid':
        component = 'payment-link/paid';
        break;
      case 'expired':
        component = 'payment-link/expired';
        break;
    }

    const module = importSync(`../../components/${component}`);

    controller.set('containerComponent', ensureSafeComponent(module.default, this));
  }
}
